import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import BackToTop from "./BackToTop";
import BackgroundBlur from "./BackgroundBlur";
import WOW from "wowjs";

const Layout = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize WOW.js for animations
    const wow = new WOW.WOW({
      live: false,
      offset: 50,
    });
    wow.init();
  }, []);

  useEffect(() => {
    // Handle hash navigation
    if (location.hash) {
      // Wait for WOW animations and React to render
      setTimeout(() => {
        const id = location.hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          const headerOffset = 100; // Adjust this value based on your header height
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      }, 300); // Delay to allow animations to initialize
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Header />
      <main className="relative">
        <BackgroundBlur position="top-right" />
        <BackgroundBlur position="bottom-left" />
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
};

export default Layout;
